import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/aceite_premium.svg")